import React from "react";
import "./whoweare.css";
import Timeline from "./timeline"; 
import { useEffect } from 'react';
import { Typography } from "@mui/material";

import AOS from 'aos';
import 'aos/dist/aos.css';

const WhoWeAre = () => {

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: false,     // whether animation should happen only once
      offset: 150,    // trigger point (px) before element enters viewport
    });
  }, []);

  return(
  <div className="wcontainer">
    <div className="wrapper" style={{background:"black"}}  >
      {/* <div
        className=""
        style={{
          display: "flex",
          justifyContent: "center",
          flexFlow: "column",
          justifyContent: "center",
          flexFlow: "column",
          alignItems: "center",
          paddingLeft: "10px",
          paddingRight: "10px",
        }}
      >
        <div className="wrapper-title">Who we are</div>
        <div className="wrapper-description pl-[8rem] pr-[8rem]">
          We offer user experience and recommendations driven by AI product
          solutions that caters to OTT, Enterprise customer. We have carved
          niche experience in OTT solution delivery with a shorter time to
          market off-the-shelf solutions with multiscreen experience.
        </div>
      </div>
      <div className="wrapper-group-visuals">
        <img src={require("../../../assets/whoweare/Hero image.png")} />
      </div> */}
       <div className="history-section">
        <div  data-aos="fade-out" className="history-info">
                      <Typography
               data-aos="zoom-in"
               style={{
                 display: "flex",
                 justifyContent: "center",
                 fontSize: "39px",
                 fontWeight: "800",
                 fontFamily: "system-ui",
                 color: "#6054E4",
            
               }}
             >Our History</Typography>
        </div>
      </div>
      <div className="bottom-asset">
        {/* <img src={require("../../../assets/aboutus/history.png")} /> */}
        <Timeline />
        <div data-aos="zoom-in">
          <img  src={require("../../../assets/aboutus/Core Values (2).png")} style={{borderRadius:"20px"}} alt="coreValues" />
       </div>
      </div>
    
     
        <div  className="horizon">
{/* <img src={require("../../../assets/aboutus/ourmission.png")} /> */}
<video src="https://d20mfvycw28oia.cloudfront.net/WebsiteVideo/Sailing_Above_Map_Markers+(online-video-cutter.com).mp4" autoPlay muted playsInline loop width="100%" height="150px" preload="auto" />
     


      <div className="applynow">
        <a
          className="elementor-button elementor-button-link elementor-size-sm"
          href="mailto:hr.bangalore@horizonind.org?subject=Join%20Us"
        >
          <div data-aos="fade">
            <img
            alt="applyBtn"
              src={require("../../../assets/aboutus/Recommendations.png")}
              className="applybtn"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
)};

export default WhoWeAre;
